import React, {memo} from "react";
import { Classes, Intent, H5 } from "@blueprintjs/core";
import classnames from "classnames";
import css from "./page.module.scss";
import TextSpan from "../TextSpan";


interface IProps {
  title: string;
  helpText?: string;
  emptyText?: string;
  titleStyle?: React.CSSProperties;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}


const Section: React.FC<IProps> = memo((props) => {

  const { children } = props;
  const hasChildren = !!children && (!Array.isArray(children) || children.length);
  const content = (hasChildren || !props.emptyText)
    ? children
    : <TextSpan muted={true} intent={Intent.WARNING} >{props.emptyText}</TextSpan>;

  return (
    <div className={classnames(css.section, props.containerClassName)} style={props.containerStyle}>
      {props.title && <div className={css.sectionHeader} style={props.titleStyle}>
        <div><H5>{props.title}</H5></div>
        {props.helpText && <div className={`${Classes.TEXT_SMALL} ${Classes.TEXT_MUTED}`}>{props.helpText}</div>}
      </div>}
      <div style={props.contentStyle}>
        {content}
      </div>
    </div>
  );
})


export default Section;

